"use client"
import Link from "next/link"
import { cn } from "@/lib/utils"
import { Button } from "@/components/fun-ui/Button"
import { usePathname } from "next/navigation";
import { CommunicateWithUs } from "@/components/CommunicateWithUs"
import { SiteLogo } from "@/components/Logo"
import { useEffect, useState } from "react"
import { landingConfig } from "@/config/landing";

interface SiteHeaderProps extends React.HTMLAttributes<HTMLElement> {

}
// 主站首页
export function SiteHeader({
  className
}: SiteHeaderProps) {
  const [cookieHasNickname, setCookieHasNickname] = useState(true);
  const pathname = usePathname();
  const isLoginPage = pathname === '/login';
  useEffect(() => {
    setCookieHasNickname(document.cookie.indexOf('nickname') !== -1);
  }, []);
  return (
    <header className={cn(
      "supports-backdrop-blur:bg-background/60 sticky top-0 z-40 w-full bg-background/60 backdrop-blur border-b shrink-0",
      "md:h-[71px]  md:border-b-[#E4E4E4]",
      "h-[100px] border-b-[#D8D8D8]",
      className,
    )}>
      <div className="container h-full flex items-center justify-between">
        <div className="flex gap-6 md:gap-10">
          <Link href="/" className="text-3xl flex items-center space-x-2 h-[46px] md:h-[32px]">
            <SiteLogo />
          </Link>
          <nav className="space-x-8 text-sm flex items-center">
            {
              landingConfig.mainNav.map(({ title, href }) => {
                return <Link className="hover:underline" key={title} href={href}>{title}</Link>
              })
            }
          </nav>
        </div>
        <nav className="flex items-center">
          <CommunicateWithUs />
          {isLoginPage ? null : (
            !cookieHasNickname ? (
              <Link
                href="/login"
                className="ml-2"
              >
                <Button className={cn(
                  "rounded-full",
                  "bg-[#F4F4F4] text-[#000000] h-14 text-xl px-8",
                  "hover:text-primary-foreground hover:bg-primary md:h-8 md:text-xs md:px-5",
                )} variant="default" >登录</Button>
              </Link>
            ) : (
              <Link
                href="/papers"
                className="ml-2"
              >
                <Button className={cn(
                  "rounded-full",
                  "bg-[#F4F4F4] text-[#000000] h-14 text-xl px-8",
                  "hover:text-primary-foreground hover:bg-primary md:h-8 md:text-xs md:px-5",
                )} variant="default" >进入 Findin</Button>
              </Link>
            )
          )}
        </nav>
      </div>
    </header>
  )
}
